<template>
  <div class="staffRecord">
    <OATable :data="data" :columns="columns" :filterData="filterData" :selectionRow="true" @search="handleSearch"
      @selectionChange="selectionChange" :loading="loading">
      <div slot="button">
        <OAButton @click="handleDepart('editDepart')" :disabled="!checkList.length">调整部门</OAButton>
        <OAButton @click="handleQuit(1)" :disabled="!checkList.length">离职</OAButton>
        <OAButton @click="handleQuit" :disabled="!checkList.length">撤销离职</OAButton>
        <OAButton @click="addStaff" class="pull-right">添加员工</OAButton>
        <a :href="herf" download="离职员工档案.xlsx">
          <OAButton v-permission="'staffAll'" class="pull-right">导出全部</OAButton>
        </a>
        <!-- <OAButton @click="downloadAll" class="pull-right">导出全部</OAButton> -->
      </div>
    </OATable>
    <OAModalForm :title="titleText" :visible.sync="dialogVisible" :saving="quitLoading" :form-data="formData"
      @on-submit="submit" @on-cancel="dialogVisible = false"></OAModalForm>
  </div>
</template>
<script>
  import {
    jump
  } from "@/common/jump";
  import OAJump from "@/components/OAJump/OAJump";
  import OAModalForm from "@/components/OAModalForm/OAModalForm";
  import {
    resFilter
  } from "@/common/util.js";
  import {
    birthData,
    recommend,
    isTrue
  } from "@/common/dictionary.js";
  import api from "@/api/apiConfig";
  import staffApi from "@/services/staff.js";

  export default {
    name: "staffRecord",
    components: {
      OAJump,
      OAModalForm
    },
    data() {
      return {
        filterData: {
          inputName: {
            formType: "a-input",
            value: undefined,
            col: 4,
            placeholder: "姓名 / 工号 / 英文名"
          },
          employeeType: {
            formType: "a-select",
            value: undefined,
            col: 4,
            code: 108,
            placeholder: "员工类型",
            options: []
          },
          companyId: {
            formType: "a-select",
            value: undefined,
            col: 4,
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            },
            placeholder: "所属公司",
            options: []
          },
          departId: {
            formType: "a-depart-cascader",
            value: undefined,
            col: 4,
            placeholder: "所在部门",
            options: []
          },
          includeChild: {
            formType: "a-select",
            value: undefined,
            col: 4,
            placeholder: "是否包含子集",
            options: isTrue
          },
          attributes: {
            formType: "a-select",
            value: undefined,
            col: 4,
            placeholder: "职位属性",
            code: 102,
            options: []
          },
          recommend: {
            formType: "a-select",
            value: undefined,
            col: 4,
            placeholder: "有无推荐人",
            options: recommend
          },
          highestEducation: {
            formType: "a-select",
            value: undefined,
            placeholder: "最高学历",
            col: 4,
            code: 101,
            options: []
          },
          sex: {
            formType: "a-select",
            value: undefined,
            placeholder: "员工性别",
            col: 4,
            code: 106,
            options: []
          },
          birth: {
            formType: "a-select",
            value: undefined,
            placeholder: "员工生日月份",
            col: 4,
            options: birthData
          },
          inductionTimeList: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "入职开始日期",
            endPlaceholder: "入职结束日期",
            col: 4
          },
          createTimeList: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "录入开始日期",
            endPlaceholder: "录入结束日期",
            col: 4
          }
        },
        columns: [{
            title: "姓名",
            key: "name",
            fixed: true,
            component: {
              name: OAJump,
              props: {
                textKey: "name",
                url: "staffDetail",
                paramKey: "userId"
              }
            },
            width: 100,
            showOverflowTooltip: true
          },
          {
            title: "工号",
            key: "number",
            fixed: true,
            minWidth: 80
          },
          {
            title: "英文名",
            key: "englishName",
            minWidth: 100
          },
          {
            title: "性别",
            key: "sexName",
            minWidth: 50
          },
          {
            title: "所属公司",
            key: "companyName",
            minWidth: 200,
            showOverflowTooltip: true
          },
          {
            title: "所在部门",
            key: "departmentName",
            minWidth: 150,
            showOverflowTooltip: true
          },
          {
            title: "职位",
            key: "positionName",
            minWidth: 150,
            showOverflowTooltip: true
          },
          {
            title: "职位属性",
            key: "attributesName",
            minWidth: 80
          },
          {
            title: "员工类型",
            key: "employeeTypeName",
            minWidth: 80
          },
          {
            title: "推荐人",
            key: "recommend",
            minWidth: 80
          },
          {
            title: "员工生日",
            key: "birthDate",
            minWidth: 100
          },
          {
            title: "最高学历",
            key: "highestEducationName",
            minWidth: 80
          },
          {
            title: "员工状态",
            key: "statusName",
            minWidth: 80
          },
          {
            title: "入职日期",
            key: "inductionTime",
            fixed: "right",
            minWidth: 100
          },
          {
            title: "录入时间",
            key: "createTime",
            fixed: "right",
            minWidth: 150
          }
        ],
        data: [],
        checkList: [],
        titleText: "",
        dialogVisible: false,
        loading: false,
        quitLoading: false,
        type: "",
        formData: {},
        herf: '/api' + api.staff.exportAll + localStorage.getItem("Authorization"),
        param: {}
      };
    },
    methods: {
      async handleSearch(val) {
        this.loading = true;
        this.param = val;
        let res = await staffApi.getStaff(val);
        this.data = res.data.data;
        this.loading = false;
      },
      selectionChange(select) {
        this.checkList = select;
      },
      handleDepart(type) {
        this.type = type;
        switch (type) {
          case "editDepart":
            let departmentId = _.map(this.checkList, item => item.departmentId);
            let positionId = _.map(this.checkList, item => item.positionId);
            let length1 = _.difference(departmentId, [departmentId[0]]);
            let length2 = _.difference(positionId, [positionId[0]]);
            if (length1.length && length2.length) {
              this.$message.warning("员工的原部门职位不一致，不允许批量调整部门");
            } else {
              this.titleText = "调整部门";
              let name = _.map(this.checkList, item => item.name);
              this.formData = {
                id: {
                  formType: "a-span",
                  value: name.join("，"),
                  label: "姓名："
                },
                departmentIds: {
                  formType: "a-depart-cascader",
                  options: [],
                  value: this.checkList[0].departmentIds,
                  placeholder: "请选择部门",
                  label: "部门：",
                  change: (formData, item) => {
                    formData.positionId.departId = _.last(item.value);
                  },
                  rules: [{
                    required: true,
                    message: "请选择部门",
                    trigger: "change"
                  }]
                },
                positionId: {
                  formType: "a-post-select",
                  departId: _.last(this.checkList[0].departmentIds),
                  value: this.checkList[0].positionId,
                  placeholder: "请选择职位",
                  label: "职位：",
                  rules: [{
                    required: true,
                    message: "请选择职位",
                    trigger: "change"
                  }]
                }
              };
              this.dialogVisible = true;
            }

            break;
          case "quit":
            this.titleText = "离职";
            this.formData = {
              name: {
                formType: "a-span",
                value: this.checkList[0].name,
                label: "姓名："
              },
              number: {
                formType: "a-span",
                value: this.checkList[0].number,
                label: "工号："
              },
              departureTime: {
                formType: "a-date-picker",
                placeholder: "请选择离职日期",
                value: this.checkList[0].terminationDate,
                label: "离职日期：",
                rules: [{
                  required: true,
                  message: "请选择离职日期",
                  trigger: "blur"
                }]
              },
              remark: {
                formType: "a-textarea",
                value: undefined,
                placeholder: "请输入离职备注",
                label: "离职备注："
              },
              dimissionFileName: {
                formType: "sky-upload-img",
                limit: 1,
                value: [],
                label: "上传附件：",
                platform: 'oa-pri-oss',
              }
            };
            break;
        }
      },
      async submit(val) {
        this.quitLoading = true
        if (this.type == "editDepart") {
          val.id = _.map(this.checkList, item => item.id);
        } else {
          delete val.name;
          delete val.number;
          val.departureTime += " 00:00:00";
          val["id"] = this.checkList[0].id;
        }
        let res = await staffApi[this.type](val);
        resFilter(res, this.handleSearch(this.param));
        this.quitLoading = false
        this.dialogVisible = false;
      },
      handleQuit(val) {
        if (this.checkList.length === 1) {
          if (this.checkList[0].status == 100007) {
            if (val == 1) {
              this.dialogVisible = true;
              this.handleDepart("quit");
            } else {
              this.cancelQuit(this.checkList[0].id);
            }
          } else {
            this.$message.warning("该员工还未提交离职申请，无法操作");
          }
        } else {
          this.$message.warning("不支持批量操作数据");
        }
      },
      cancelQuit(id) {
        this.$confirm("是否确认撤销此员工的离职申请？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false
          })
          .then(async () => {
            let res = await staffApi.cancelQuit({
              id: id
            });
            resFilter(res, this.handleSearch(this.param));
          })
          .catch(() => {});
      },
      addStaff() {
        jump({
          url: "staffDetail"
        });
      },
        async downloadAll() {
          let param={
            status:100001,
            token:localStorage.getItem("Authorization")
          }
          let res = await staffApi.downloadAll(param);
          console.log(res);
        }
    }
  };

</script>



// WEBPACK FOOTER //
// src/pages/personnel/staffRecord.vue